import { 
    Reporter,
    IReportingEvent,
    ITrackingServerConfig,
} from '@andromeda/telemetry-data-access-orion';

export interface ITrackingState {
    trackingConfigs: ITrackingServerConfig[];
    reporters: Reporter[];
    reportQueue: IReportingEvent[];
};

export const state: ITrackingState = {
    trackingConfigs: [],
    reporters: [],
    reportQueue: [],
};
